class TagalysCarousel extends HTMLElement {
  constructor () {
    super()

    this.elements = {
      sliderComponent: this.querySelector('slider-component'),
      carousel: this.querySelector('[data-tagalys-carousel-el="carousel"]')
    }

    this.state = {
      recommendationId: this.dataset.recommendationId,
      productId: this.dataset.productId,
      backupData: this.dataset.backupData,
      template: this.dataset.template,
      limit: Number(this.dataset.limit),
      type: this.dataset.type,
    }

  }

  connectedCallback () {
    onTagalysReady(() => {
      if (this.state.template !== 'product') {
        this.state.productId = false
      }
      this.fetchRecommendations()
    })
  }

  fetchRecommendations () {
    const requiredProductIdParams = {
      recommendationId: this.state.type === 'recently-viewed' ? 'recently_viewed_products' : this.state.recommendationId,
      productIds: [this.state.productId],
      count: this.state.limit
    }

    const params = {
      recommendationId: this.state.type === 'recently-viewed' ? 'recently_viewed_products' : this.state.recommendationId,
      count: this.state.limit
    }

    window.Tagalys.APIConnector.Recommendations.call({
      params: this.state.productId ? requiredProductIdParams : params,
      onSuccess: response => {
        const { products } = response

        if (products.length === 0) {
          if (this.state.backupData === 'shopify_recommendations') {
            this.fetchShopifyRecommendations()
          } else if (this.state.backupData === 'recently_viewed_storage') {
            this.fetchRecentlyViewedRecommendations()
          }
          return
        }

        const handles = products.map(product => product.handle)

        this.renderProductCards(handles)
      },
      onFailure: response => {
        console.error('Failed to fetch recommendations', response)
        if (this.state.backupData === 'shopify_recommendations') {
          this.fetchShopifyRecommendations()
        } else if (this.state.backupData === 'recently_viewed_storage') {
          this.fetchRecentlyViewedRecommendations()
        }
      }
    })
  }

  async fetchShopifyRecommendations () {
    try {
    const response = await fetch(`/recommendations/products.json?product_id=${this.state.productId}&intent=related`)
      const { products } = await response.json()
      const handles = products.map(product => product.handle)

      return this.renderProductCards(handles)
    } catch (error) {
      this.instructTabPanelToHide()
      console.error('Failed to fetch Shopify recommendations', error)
      return
    }
  }

  instructTabPanelToHide () {
    const customEvent = new CustomEvent('tagalys:tab-panel:hide', {
      bubbles: true,
      detail: {
        type: this.state.type,
      }
    })
    this.dispatchEvent(customEvent)
  }

  async fetchRecentlyViewedRecommendations () {
    const recentlyViewed = window.localStorage.getItem(this.storageKey)

    if (!recentlyViewed) {
      this.instructTabPanelToHide()
      return
    }

    const handles = recentlyViewed.split(',')
    return this.renderProductCards(handles)
  }

  async getProductCards (handles) {
    const productCardNodes = await Promise.all(
      handles.map(async handle => {
        const productCardHTML = await this.getProductCardHTML(handle)

        const template = document.createElement('template')
        template.innerHTML = productCardHTML.trim()

        const productCardEl = template.content.querySelector('product-recommendation-card')


        if (!productCardEl) return false

        if(productCardEl.querySelector('a')?.href === '') return false

        const listItem = document.createElement('li')
        listItem.classList.add('slider__slide')
        listItem.appendChild(productCardEl)

        return listItem
      }),
    )

    return productCardNodes
  }

  async renderProductCards (handles) {
    const first15Handles = handles.slice(0, 15)

    const productCardNodes = await this.getProductCards(first15Handles)

    const validNodes = productCardNodes.filter(Boolean)

    if (validNodes.length === 0) {
      this.instructTabPanelToHide()
      return
    }

    const fragment = document.createDocumentFragment()
    validNodes.forEach(li => fragment.appendChild(li))

    this.elements.carousel.appendChild(fragment)
    await this.initialiseSlider()
    this.setSliderButtonsPosition()

    const cardCount = this.querySelectorAll('.slider__slide').length

    this.dataset.showMobileArrows = cardCount > 2 ? 'true' : 'false'
    this.dataset.showDesktopArrows = cardCount > 6 ? 'true' : 'false'

    const customEvent = new CustomEvent('tagalys:carousel:products:fetched', {
      bubbles: true,
    })
    this.dispatchEvent(customEvent)
  }

  setSliderButtonsPosition () {
    const hasHeight = getComputedStyle(document.body).getPropertyValue('--tagalys-carousel-image-height')

    if (hasHeight === '' || hasHeight === '0px') {
      const slides = this.querySelectorAll('.slider__slide')

      if (slides.length === 0) {
        return
      }

      const image = slides[0].querySelector('img')

      if (!image) {
        return
      }

      const imageHeight = image.offsetHeight

      const buttons = this.querySelectorAll('.slider-button')

      document.body.style.setProperty('--tagalys-carousel-image-height', `${imageHeight / 2}px`)

      buttons.forEach(button => {
        button.style.top = `var(--tagalys-carousel-image-height)`
        button.style.transform = 'translateY(-50%)'
      })
    }
  }

  async getProductCardHTML (handle) {
    const response = await fetch(`/products/${handle}/?section_id=product-recommendation-card`)
    const section = await response.text()

    return section
  }

  async initialiseSlider () {
    const slider = this.elements.sliderComponent

    slider.init()

    this.dataset.initialised = true

    return new Promise(resolve => {
      return resolve(slider)
    })
  }

  get storageKey () {
    return 'BAO_RECENTLY_VIEWED'
  }
}

customElements.define('tagalys-carousel', TagalysCarousel)
